class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;
  cartSellingPlanUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );

    this.cartSellingPlanUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartSellingPlanUpdate,
      (event) => {
        this.onSellingPlanUpdate(
          event.state,
          event.line,
          event.name,
          event.variantId
        );
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
    if (this.cartSellingPlanUpdateUnsubscriber) {
      this.cartSellingPlanUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    if (!input) return;
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = "";

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace(
        "[min]",
        event.target.dataset.min
      );
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace(
        "[max]",
        event.target.max
      );
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace(
        "[step]",
        event.target.step
      );
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;

          const sourceFooter = html.querySelector(".cart__footer ");
          const footer = document.querySelector(".cart__footer ");

          footer.querySelector(".js-contents").innerHTML =
            sourceFooter.querySelector(".js-contents").innerHTML;

          const sourceCartUpsell = document.querySelector(
            ".cart__upsell-product"
          );
          const sourceCartUpsellSticky = document.querySelector(
            ".sticky-upsell-product"
          );

          const cartUpsell = html.querySelector(".cart__upsell-product");
          const cartUpsellSticky = html.querySelector(".sticky-upsell-product");

          if (cartUpsell && sourceCartUpsell) {
            if (cartUpsell.classList.contains("hidden"))
              sourceCartUpsell.classList.add("hidden");
            else sourceCartUpsell.classList.remove("hidden");
          }

          if (cartUpsellSticky && sourceCartUpsellSticky) {
            if (cartUpsellSticky.classList.contains("hidden"))
              sourceCartUpsellSticky.classList.add("hidden");
            else sourceCartUpsellSticky.classList.remove("hidden");
          }

          const sellingPlanSelectors = document.querySelectorAll(
            '[name^="purchaseOption_"]'
          ); // Select based on name prefix

          sellingPlanSelectors.forEach(function (element) {
            element.addEventListener("change", function (event) {
              const line = event.target.dataset.line;
              const quantity = event.target.dataset.quantity;
              const sellingPlanId = event.target.dataset.sellingPlanId;
              const variantId = event.target.dataset.variantId;

              const parentWrapper = element.closest(".selling-plans-list");
              const selectedPreviously = parentWrapper.querySelector(
                ".has-selected-input"
              );
              if (selectedPreviously) {
                selectedPreviously.classList.remove("has-selected-input");
              }

              enableLoadingTemp(line);
              const body = JSON.stringify({
                line: line,
                quantity: quantity,
                selling_plan: sellingPlanId,
                sections: getSectionsToRenderTemp().map(
                  (section) => section.section
                ),
                sections_url: window.location.pathname,
              });

              fetch(`${routes.cart_change_url}`, {
                ...fetchConfig(),
                ...{ body },
              })
                .then((response) => {
                  return response.text();
                })
                .then((state) => {
                  publish(PUB_SUB_EVENTS.cartSellingPlanUpdate, {
                    state: state,
                    line: line,
                    name: document.activeElement.getAttribute("name"),
                    variantId: variantId,
                  });
                })
                .catch((error) => {
                  console.error("Error:", error);
                });
            });
          });
          // const sourceFooter = html.querySelector('#main-cart-footer');
          // if(sourceFooter) document.getElementById('main-cart-footer').innerHTML = sourceFooter.innerHTML;

          // const sourceSticky = html.querySelector('.sticky-upsell-wrapper ');
          // if(sourceSticky) document.querySelector('.sticky-upsell-wrapper ').innerHTML = sourceSticky.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(
    line,
    quantity,
    name,
    variantId,
    addingFreeProduct,
    disableLineLoading
  ) {
    if (!disableLineLoading) this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        try {
          const parsedState = JSON.parse(state);
          const freeSubscriptionProduct = document.querySelector(
            "[data-free-subscription-product]"
          );

          // TODO: make better, not hardcoded
          const goodFibesId = "45790844027105";
          const lineItemForUpdate =
            document.getElementById(`CartItem-${line}`) ||
            document.getElementById(`CartDrawer-Item-${line}`);
          let sellingPlanSelected = null;
          if (
            lineItemForUpdate &&
            lineItemForUpdate.querySelector("input:checked")
          ) {
            sellingPlanSelected = lineItemForUpdate
              .querySelector("input:checked")
              .getAttribute("data-selling-plan-id");
          }

          if (
            freeSubscriptionProduct &&
            !addingFreeProduct &&
            sellingPlanSelected
          ) {
            const freeSubscriptionProductId =
              freeSubscriptionProduct.getAttribute(
                "data-free-subscription-product-id"
              );
            const freeSubscriptionProductQtyInput = document.querySelector(
              `[data-quantity-variant-id="${freeSubscriptionProductId}"]`
            );
            const freeSubscriptionProductLine =
              freeSubscriptionProductQtyInput.getAttribute("data-index");

            const numberOfSubscriptionsInCart = parsedState.items.reduce(
              (count, item) => {
                if (item.selling_plan_allocation && item.id != goodFibesId) {
                  return count + item.quantity;
                }
                return count;
              },
              0
            );
            // in case we have reduced the qty, the free subscription line would separate into two - one with discount and one without so we need to check this
            const numberOfFreeSubscriptionProductLines =
              parsedState.items.filter(
                (item) => item.id == freeSubscriptionProductId
              ).length;

            if (line != freeSubscriptionProductLine) {
              if (numberOfFreeSubscriptionProductLines > 1) {
                const freeSubscriptionProductLineAll =
                  document.querySelectorAll(
                    `[data-quantity-variant-id="${freeSubscriptionProductId}"]`
                  );
                const freeSubscriptionsInCart = parsedState.items.filter(
                  (item) => item.id == freeSubscriptionProductId
                );

                // in case the left over ones with discount have a smaller qty than the non-discount ones
                // Example (all products have subscription selected):
                // ATC = 20 in cart, Berberine = 5 in cart
                // We remove ATC
                // What's currently in the cart is 5 Pill Cases with discount, and 20 without discount
                // If we don't select the ones without discount, we would try to remove 15 units from the ones with discount
                // Which is impossible and fails

                let highestValueElement = freeSubscriptionsInCart[0];
                let highestValue = freeSubscriptionsInCart[0].quantity;

                freeSubscriptionsInCart.forEach((element) => {
                  const value = element.quantity;

                  if (value > highestValue) {
                    highestValue = value;
                    highestValueElement = element;
                  }
                });

                const highestValueElementIndex = Array.from(
                  parsedState.items
                ).indexOf(highestValueElement);
                const qtyInputValue = Number(
                  freeSubscriptionProductQtyInput.value
                );
                const newQty =
                  numberOfSubscriptionsInCart <
                  qtyInputValue - numberOfSubscriptionsInCart
                    ? 0
                    : numberOfSubscriptionsInCart -
                      (qtyInputValue - numberOfSubscriptionsInCart);

                this.updateQuantity(
                  highestValueElementIndex + 1,
                  newQty,
                  null,
                  null,
                  true
                );
                // this.updateQuantity(freeSubscriptionProductLine, numberOfSubscriptionsInCart - (Number(freeSubscriptionProductQtyInput.value) - numberOfSubscriptionsInCart), null, null, true);
              } else {
                this.updateQuantity(
                  freeSubscriptionProductLine,
                  numberOfSubscriptionsInCart,
                  null,
                  null,
                  true
                );
              }
              console.log("Returning due to freeSubscriptionProduct logic");
              return;
            }
          }
          const quantityElement =
            document.getElementById(`Quantity-${line}`) ||
            document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll(".cart-item");
          if (parsedState.errors) {
            console.error("Cart update error:", parsedState.errors); // <--- Add this
            quantityElement.value = quantityElement.getAttribute("value");
            this.updateLiveRegions(line, parsedState.errors);
            console.log("Returning due to parsedState.errors");
            return;
          }

          this.classList.toggle("is-empty", parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector("cart-drawer");
          const cartFooter = document.getElementById("main-cart-footer");
          const cartUpsell = document.querySelector(".cart__upsell-product");
          const cartUpsellSticky = document.querySelector(
            ".sticky-upsell-product"
          );

          if (cartFooter)
            cartFooter.classList.toggle(
              "is-empty",
              parsedState.item_count === 0
            );
          if (cartUpsell) {
            const upsellProductId = cartUpsell.getAttribute(
              "data-upsell-product-id"
            );
            const isUpsellInCart = parsedState.items.some(
              (item) => item.product_id == upsellProductId
            );

            if (cartUpsell && cartUpsellSticky) {
              if (isUpsellInCart) {
                cartUpsell.classList.add("hidden");
                cartUpsellSticky.classList.add("hidden");
              } else {
                cartUpsell.classList.remove("hidden");
                cartUpsellSticky.classList.remove("hidden");
              }
            }
          }
          if (cartDrawerWrapper)
            cartDrawerWrapper.classList.toggle(
              "is-empty",
              parsedState.item_count === 0
            );

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1]
            ? parsedState.items[line - 1].quantity
            : undefined;
          let message = "";

          console.log(
            "updatedValue:",
            updatedValue,
            "inputValue:",
            quantityElement.value,
            "parsedState.items:",
            parsedState.items
          );

          if (
            items.length === parsedState.items.length &&
            updatedValue !== parseInt(quantityElement.value)
          ) {
            if (typeof updatedValue === "undefined") {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace(
                "[quantity]",
                updatedValue
              );
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) ||
            document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(
                  cartDrawerWrapper,
                  lineItem.querySelector(`[name="${name}"]`)
                )
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(
              cartDrawerWrapper.querySelector(".drawer__inner-empty"),
              cartDrawerWrapper.querySelector("a")
            );
          } else if (
            document.querySelector(".cart-item") &&
            cartDrawerWrapper
          ) {
            trapFocus(
              cartDrawerWrapper,
              document.querySelector(".cart-item__name")
            );
          }

          // TODO: make better
          const sellingPlanSelectors = document.querySelectorAll(
            '[name^="purchaseOption_"]'
          );
          sellingPlanSelectors.forEach((sellingPlanSelector) => {
            sellingPlanSelector.addEventListener("change", function (event) {
              const line = event.target.dataset.line;
              const quantity = event.target.dataset.quantity;
              const sellingPlanId = event.target.dataset.sellingPlanId;
              const variantId = event.target.dataset.variantId;

              const parentWrapper = sellingPlanSelector.closest(
                ".selling-plans-list"
              );
              const selectedPreviously = parentWrapper.querySelector(
                ".has-selected-input"
              );
              if (selectedPreviously) {
                selectedPreviously.classList.remove("has-selected-input");
              }

              enableLoadingTemp(line);
              const body = JSON.stringify({
                line: line,
                quantity: quantity,
                selling_plan: sellingPlanId,
                sections: getSectionsToRenderTemp().map(
                  (section) => section.section
                ),
                sections_url: window.location.pathname,
              });

              fetch(`${routes.cart_change_url}`, {
                ...fetchConfig(),
                ...{ body },
              })
                .then((response) => {
                  return response.text();
                })
                .then((state) => {
                  // TODO: make better, not hardcoded
                  publish(PUB_SUB_EVENTS.cartSellingPlanUpdate, {
                    state: state,
                    line: line,
                    name: document.activeElement.getAttribute("name"),
                    variantId: variantId,
                  });
                })
                .catch((error) => {
                  console.error("Error:", error);
                });
            });
          });
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "cart-items",
            cartData: parsedState,
            variantId: variantId,
          });
        } catch (e) {
          console.error("Error in .then block:", e);
        }
      })

      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        if (!disableLineLoading) this.disableLoading(line);
      });
  }

  onSellingPlanUpdate(state, line, name, variantId) {
    const parsedState = JSON.parse(state);

    const freeSubscriptionProduct = document.querySelector(
      "[data-free-subscription-product]"
    );
    const goodFibesId = "45790844027105";
    const lineItemForUpdate =
      document.getElementById(`CartItem-${line}`) ||
      document.getElementById(`CartDrawer-Item-${line}`);
    let sellingPlanSelected = null;
    if (lineItemForUpdate && lineItemForUpdate.querySelector("input:checked")) {
      sellingPlanSelected = lineItemForUpdate
        .querySelector("input:checked")
        .getAttribute("data-selling-plan-id");
    }
    if (freeSubscriptionProduct) {
      const freeSubscriptionProductId = freeSubscriptionProduct.getAttribute(
        "data-free-subscription-product-id"
      );
      const freeSubscriptionProductQtyInput = document.querySelector(
        `[data-quantity-variant-id="${freeSubscriptionProductId}"]`
      );
      const freeSubscriptionProductLine = freeSubscriptionProductQtyInput
        ? freeSubscriptionProductQtyInput.getAttribute("data-index")
        : null;

      const numberOfSubscriptionsInCart = parsedState.items.reduce(
        (count, item) => {
          if (item.selling_plan_allocation && item.id != goodFibesId) {
            return count + item.quantity;
          }
          return count;
        },
        0
      );

      const numberOfFreeSubscriptionProductLines = parsedState.items.filter(
        (item) => item.id == freeSubscriptionProductId
      ).length;

      if (line != freeSubscriptionProductLine) {
        if (freeSubscriptionProductLine) {
          if (numberOfFreeSubscriptionProductLines > 1) {
            const freeSubscriptionProductLineAll = document.querySelectorAll(
              `[data-quantity-variant-id="${freeSubscriptionProductId}"]`
            );
            const freeSubscriptionsInCart = parsedState.items.filter(
              (item) => item.id == freeSubscriptionProductId
            );

            // in case the left over ones with discount have a smaller qty than the non-discount ones
            // Example (all products have subscription selected):
            // ATC = 20 in cart, Berberine = 5 in cart
            // We remove ATC
            // What's currently in the cart is 5 Pill Cases with discount, and 20 without discount
            // If we don't select the ones without discount, we would try to remove 15 units from the ones with discount
            // Which is impossible and fails

            let highestValueElement = freeSubscriptionsInCart[0];
            let highestValue = freeSubscriptionsInCart[0].quantity;

            freeSubscriptionsInCart.forEach((element) => {
              const value = element.quantity;

              if (value > highestValue) {
                highestValue = value;
                highestValueElement = element;
              }
            });

            const highestValueElementIndex = Array.from(
              parsedState.items
            ).indexOf(highestValueElement);
            const qtyInputValue = Number(freeSubscriptionProductQtyInput.value);
            const newQty =
              numberOfSubscriptionsInCart <
              qtyInputValue - numberOfSubscriptionsInCart
                ? 0
                : numberOfSubscriptionsInCart -
                  (qtyInputValue - numberOfSubscriptionsInCart);

            this.updateQuantity(
              highestValueElementIndex + 1,
              newQty,
              null,
              null,
              true
            );
          } else {
            this.updateQuantity(
              freeSubscriptionProductLine,
              numberOfSubscriptionsInCart,
              null,
              null,
              true
            );
          }
          return;
        } else {
          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          let formData = new FormData();
          formData.append("id", freeSubscriptionProductId);
          formData.append("quantity", numberOfSubscriptionsInCart);
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              this.onCartUpdate();
            })
            .catch((e) => {
              console.error(e);
            });
          return;
        }
      }
    }

    const quantityElement =
      document.getElementById(`Quantity-${line}`) ||
      document.getElementById(`Drawer-quantity-${line}`);
    const items = document.querySelectorAll(".cart-item");

    if (parsedState.errors) {
      quantityElement.value = quantityElement.getAttribute("value");
      this.updateLiveRegions(line, parsedState.errors);
      return;
    }

    this.classList.toggle("is-empty", parsedState.item_count === 0);
    const cartDrawerWrapper = document.querySelector("cart-drawer");
    const cartFooter = document.getElementById("main-cart-footer");
    const cartUpsell = document.querySelector(".cart__upsell-product");
    const cartUpsellSticky = document.querySelector(".sticky-upsell-product");

    if (cartFooter)
      cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
    if (cartUpsell) {
      const upsellProductId = cartUpsell.getAttribute("data-upsell-product-id");
      const isUpsellInCart = parsedState.items.some(
        (item) => item.product_id == upsellProductId
      );

      if (isUpsellInCart) {
        cartUpsell.classList.add("hidden");
        cartUpsellSticky.classList.add("hidden");
      } else {
        cartUpsell.classList.remove("hidden");
        cartUpsellSticky.classList.remove("hidden");
      }
    }
    if (cartDrawerWrapper)
      cartDrawerWrapper.classList.toggle(
        "is-empty",
        parsedState.item_count === 0
      );

    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) ||
        document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );
    });
    const updatedValue = parsedState.items[line - 1]
      ? parsedState.items[line - 1].quantity
      : undefined;
    let message = "";
    if (
      items.length === parsedState.items.length &&
      updatedValue !== parseInt(quantityElement.value)
    ) {
      if (typeof updatedValue === "undefined") {
        message = window.cartStrings.error;
      } else {
        message = window.cartStrings.quantityError.replace(
          "[quantity]",
          updatedValue
        );
      }
    }
    this.updateLiveRegions(line, message);

    const lineItem =
      document.getElementById(`CartItem-${line}`) ||
      document.getElementById(`CartDrawer-Item-${line}`);
    if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
      cartDrawerWrapper
        ? trapFocus(
            cartDrawerWrapper,
            lineItem.querySelector(`[name="${name}"]`)
          )
        : lineItem.querySelector(`[name="${name}"]`).focus();
    } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
      trapFocus(
        cartDrawerWrapper.querySelector(".drawer__inner-empty"),
        cartDrawerWrapper.querySelector("a")
      );
    } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper, document.querySelector(".cart-item__name"));
    }

    // TODO: make better, general listener in main-cart-items
    const sellingPlanSelectors = document.querySelectorAll(
      '[name^="purchaseOption_"]'
    );
    sellingPlanSelectors.forEach((sellingPlanSelector) => {
      sellingPlanSelector.addEventListener("change", function (event) {
        const line = event.target.dataset.line;
        const quantity = event.target.dataset.quantity;
        const sellingPlanId = event.target.dataset.sellingPlanId;
        const variantId = event.target.dataset.variantId;

        const parentWrapper = sellingPlanSelector.closest(
          ".selling-plans-list"
        );
        const selectedPreviously = parentWrapper.querySelector(
          ".has-selected-input"
        );
        if (selectedPreviously) {
          selectedPreviously.classList.remove("has-selected-input");
        }

        enableLoadingTemp(line);
        const body = JSON.stringify({
          line: line,
          quantity: quantity,
          selling_plan: sellingPlanId,
          sections: getSectionsToRenderTemp().map((section) => section.section),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            publish(PUB_SUB_EVENTS.cartSellingPlanUpdate, {
              state: state,
              line: line,
              name: document.activeElement.getAttribute("name"),
              variantId: variantId,
            });
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      });
    });

    this.disableLoading(line);
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: "cart-items",
      cartData: parsedState,
      variantId: variantId,
    });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").textContent =
        message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
